import http from "../../services/http";
import { updateSection } from "../entities/classInfoById";
import { updateSectionSidebar } from "../entities/createClass";
const path = "api";

const sectionUpdate = ({ body = {}, onSuccess, onError, onEnd, id }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/section/${id}`,
        body,
        headers: { "x-auth-token": store.auth.token },
      });
      dispatch(updateSection(res.data.data));
      dispatch(updateSectionSidebar(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const teacherAssitantEmail = ({ onSuccess, onError, onEnd, id, body }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/section/listofteacherassistant/${id}`,
        body,
        headers: { "x-auth-token": store.auth.token },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { sectionUpdate, teacherAssitantEmail };
